import PropTypes from 'prop-types';
import React from 'react';

import { shopClickDrive } from 'commons-vehicle/services/ThirdPartiesJs/ThirdParties.js';

import 'commons-vehicle/Vehicle/components/CallToAction/ThirdParties/ShopClickDrive/ShopClickDriveCTA.scss';

const ShopClickDriveCTA = ({ buttonClass, ctaLabel, dealerBac, make, serialNo, lang }) => {
    const shopClickDriveUrl = dealerBac && shopClickDrive(make, dealerBac, serialNo, lang);

    if (!dealerBac || !shopClickDriveUrl) return null;

    return (
        <a
            href={`${shopClickDriveUrl}`}
            target="_blank"
            rel="noreferrer"
            onClick="event.stopPropagation()"
            className={`${buttonClass} shopClickDrive-cta`}
        >
            <span className="shopClickDrive-label">{ctaLabel}</span>
        </a>
    );
};

ShopClickDriveCTA.defaultProps = {
    buttonClass: 'sr-button-1',
    alternativeLabel: null,
    serialNo: '',
    lang: 'en',
    dealerBac: '',
    make: '',
    ctaLabel: '',
};

ShopClickDriveCTA.propTypes = {
    buttonClass: PropTypes.string,
    ctaLabel: PropTypes.string,
    serialNo: PropTypes.string,
    lang: PropTypes.string,
    dealerBac: PropTypes.string,
    make: PropTypes.string,
};

ShopClickDriveCTA.displayName = 'ShopClickDriveCTA';

export default ShopClickDriveCTA;
